import styles from "../../../movein-checklist.module.css";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { X } from "react-feather";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";
import NumberFormat from "react-number-format";

const schema = yup.object().shape({
  otherExteriorOfBuilding: yup.string(),
  otherExteriorOfBuildingOther: yup.string(),
  otherLawnGarden: yup.string(),
  otherLawnGardenOther: yup.string(),
  otherDrivewayWalkways: yup.string(),
  otherDrivewayWalkwaysOther: yup.string(),
  otherGarage: yup.string(),
  otherGarageOther: yup.string(),
  otherPorch: yup.string(),
  otherPorchOther: yup.string(),
  otherDoor: yup.string(),
  otherDoorOther: yup.string(),
  otherMailbox: yup.string(),
  otherMailboxOther: yup.string(),
  otherOther: yup.string(),
  otherOtherOther: yup.string(),
});

const OtherForm = ({ onSubmitArrivalForm, setLoading, moveInCheckListInfo, handleChange4 }) => {
  const [uploadedImages, setUploadedImages] = useState([]);
  const { getAccessTokenSilently } = useAuth0();

  const { control, handleSubmit, setValue } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const otherValues = useWatch({ control });

  useEffect(() => {
    if (!moveInCheckListInfo?.other_data) return;

    const data = moveInCheckListInfo.other_data;

    Object.entries(data).forEach(([key, field]) => {
      if (!field || typeof field !== "object") return;
    });

  }, [moveInCheckListInfo, setValue]);

  const onSubmit = (data) => {
    const sectionName = "other_data";
    const formattedData = {
      otherExteriorOfBuilding: { value: data.otherExteriorOfBuilding === "other" ? data.otherExteriorOfBuildingOther : data.otherExteriorOfBuilding, is_other: data.otherExteriorOfBuilding === "other" ? 1 : 0 },
      otherLawnGarden: { value: data.otherLawnGarden === "other" ? data.otherLawnGardenOther : data.otherLawnGarden, is_other: data.otherLawnGarden === "other" ? 1 : 0 },
      otherDrivewayWalkways: { value: data.otherDrivewayWalkways === "other" ? data.otherDrivewayWalkwaysOther : data.otherDrivewayWalkways, is_other: data.otherDrivewayWalkways === "other" ? 1 : 0 },
      otherGarage: { value: data.otherGarage === "other" ? data.otherGarageOther : data.otherGarage, is_other: data.otherGarage === "other" ? 1 : 0 },
      otherPorch: { value: data.otherPorch === "other" ? data.otherPorchOther : data.otherPorch, is_other: data.otherPorch === "other" ? 1 : 0 },
      otherDoorKeyfobs: { value: data.otherDoorKeyfobs, is_other: 0 },
      otherDoorKeys: { value: data.otherDoorKeys, is_other: 0 },
      otherMailboxKeys: { value: data.otherMailboxKeys, is_other: 0 },
      otherOther: { value: data.otherOther === "other" ? data.otherOtherOther : data.otherOther, is_other: data.otherOther === "other" ? 1 : 0 }
    };

    const imageFiles = uploadedImages.map((img) => img.file_path);
    const imageSectionName = "other_images";

    onSubmitArrivalForm(formattedData, sectionName, imageFiles, imageSectionName);

  };

  const handleImageChange = async (event) => {
    const files = Array.from(event.target.files);
    setLoading(true);

    try {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      for (const file of files) {
        const formData = new FormData();
        formData.append("image", file);

        const response = await axios.post(process.env.REACT_APP_PAYMENT_API_URL + `v1/move-in-report-file-upload`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          }
        });

        const { file_path, file_url } = response.data.data;

        setUploadedImages((prev) => [...prev, { file_path, file_url }]);
      }
      toast.success(`Images are uploaded`);
    } catch (error) {
      console.error("Upload error:", error);
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Image upload failed");
      }
    } finally {
      setLoading(false);
    }
  };

  const removeImage = (fileNameToRemove) => {
    setUploadedImages((prev) =>
      prev.filter((img) => img.file_path !== fileNameToRemove)
    );
  };

  return (<div className={`${styles.FormSec}`}>
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>1. Exterior of Building</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="otherExteriorOfBuilding"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {otherValues?.otherExteriorOfBuilding === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="otherExteriorOfBuildingOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>2. Lawn/Garden</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="otherLawnGarden"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {otherValues?.otherLawnGarden === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="otherLawnGardenOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>3. Driveway/Walkways</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="otherDrivewayWalkways"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {otherValues?.otherDrivewayWalkways === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="otherDrivewayWalkwaysOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>4. Garage</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="otherGarage"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {otherValues?.otherGarage === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="otherGarageOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>5. Porch</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select</InputLabel>
              <Controller
                name="otherPorch"
                control={control}
                render={(field) => (<Select {...field} label="Select">
                  <MenuItem value="new">New</MenuItem>
                  <MenuItem value="normal">Normal</MenuItem>
                  <MenuItem value="damaged">Damaged</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                  <MenuItem value="N/A">N/A</MenuItem>
                </Select>)}
              />
            </FormControl>
          </div>
          {otherValues?.otherPorch === "other" && (<div className={`${styles.FormFullSec} FormGroup`}>
            <Controller
              name="otherPorchOther"
              control={control}
              render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
            />
          </div>)}
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>6. # key fobs given</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <Controller
                name="otherDoorKeyfobs"
                control={control}
                render={(field) => (
                  <NumberFormat
                    {...field}
                    customInput={TextField}
                    format="##"
                    label="No. Of Keyfobs"
                  />)}
              />
            </FormControl>
          </div>
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>7. # of physical keys given</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <Controller
                name="otherDoorKeys"
                control={control}
                render={(field) => (
                  <NumberFormat
                    {...field}
                    customInput={TextField}
                    format="##"
                    label="No. Of Keys"
                  />)}
              />
            </FormControl>
          </div>
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>8. # of mailbox keys given</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <Controller
                name="otherMailboxKeys"
                control={control}
                render={(field) => (
                  <NumberFormat
                    {...field}
                    customInput={TextField}
                    format="##"
                    label="No. Of Mailbox Keys"
                  />)}
              />
            </FormControl>
          </div>
        </div>
      </div>
      <div className={`${styles.FormList}`}>
        <p className={`${styles.Title}`}>9. Other</p>
        <div className={`${styles.FormListRow}`}>
          <div className={`${styles.FormFullSec} FormGroup`}>
            <FormControl fullWidth>
              <Controller
                name="otherOther"
                control={control}
                render={(field) => (<TextField {...field} fullWidth label="Add Description" />)}
              />
            </FormControl>
          </div>
        </div>
      </div>

      <div className={`${styles.HalfSecFull}`}>
        <div className={`${styles.FileUpDuBUDiv}`}>
          <label htmlFor="file-upload-other" className={`${styles.UploadLabel}`}>
            <span>
              <div className={`${styles.UpIcon}`}>
                <img src="/static/img/upload-floor.svg" alt="" />
              </div>
              <p>Upload Pictures</p>
              <p className={`${styles.UploadText}`}>File size upto 5 MB</p>
            </span>
          </label>
          <input id="file-upload-other" type="file" accept="image/*" multiple onChange={handleImageChange} style={{ display: "none" }} />
        </div>

        <div className={`${styles.UpIMGSec}`}>
          {uploadedImages.map((img, index) => (<div key={index} className={`${styles.ImgFile}`}>
            <img src={img.file_url} alt={img.file_path} />
            <Button type="button" onClick={() => removeImage(img.file_path)}><X /></Button>
          </div>))}
        </div>
      </div>

      <div className={`${styles.ButtonAction}`}>
        <Button className={`${styles.CancelPopupBU}`} onClick={handleChange4("panel5")}>Cancel</Button>
        <Button type="submit" className={`${styles.SubmitPopupBU}`}>Save & Continue</Button>
      </div>
    </form>
  </div>);
};

export default OtherForm;